var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltipArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.7 1.06667L0.0406182 5.94584C0.0238826 5.96816 0.0398043 6 0.067697 6H8.96875C8.98163 6 8.98898 5.9853 8.98125 5.975L5.3 1.06667C4.9 0.533333 4.1 0.533334 3.7 1.06667Z",
    fill: "#0B212C",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipArrowIcon);
export default __webpack_public_path__ + "static/media/TooltipArrowIcon.938bd328f1a2ee57c5d354aeb0ffa5e0.svg";
export { ForwardRef as ReactComponent };